export function mapProps<T>(variants: T) {
  return <K extends keyof T>(variant: K): T[K] => {
    return variants[variant];
  };
}
